﻿export default (() => {
	function setupEvents() {
		const $lazyBackgroundElements = document.querySelectorAll("[data-responsive-bg]");

		$lazyBackgroundElements.forEach(($element) => {
			const $sourceSets = $element.children;
			initializeResponsiveBackGroundElement($element, $sourceSets);
		});
	}

	function initializeResponsiveBackGroundElement($element, $sourceSets) {
		if (!$sourceSets) {
			return;
		}

		const currentWidth = window.innerWidth;

		for (let $sourceSet of $sourceSets) {
			if (currentWidth > $sourceSet.dataset.bgBreakpoint) {
				$element.style.backgroundImage = `url(${$sourceSet.dataset.bgUrl})`;

				break;
			}
		}
	}

	setupEvents();
})();
